var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import i18next from 'i18next';
export var customLoadI18NextModule = function (_a) {
    var namespaces = _a.namespaces, router = _a.router, version = _a.version, localDictionaryFiles = _a.localDictionaryFiles;
    return __awaiter(void 0, void 0, void 0, function () {
        var _b, i18nextRequest, getI18nextRequestEndpoint, getLocale, locale, result;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _b = router.getDependencies().i18nextConfig, i18nextRequest = _b.i18nextRequest, getI18nextRequestEndpoint = _b.createEndpoint, getLocale = _b.getLocale;
                    locale = getLocale();
                    return [4 /*yield*/, Promise.all(namespaces.map(function (namespace) { return __awaiter(void 0, void 0, void 0, function () {
                            var wasResourceDownloaded, endpoint, isFileRequest, _a, data, error, errorText, formattedTranslateData, error_1;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        wasResourceDownloaded = Boolean(i18next.getResourceBundle(locale, namespace));
                                        if (wasResourceDownloaded) {
                                            return [2 /*return*/];
                                        }
                                        _b.label = 1;
                                    case 1:
                                        _b.trys.push([1, 3, , 4]);
                                        endpoint = localDictionaryFiles
                                            ? localDictionaryFiles[locale]
                                            : getI18nextRequestEndpoint({
                                                namespace: namespace,
                                                locale: locale,
                                            });
                                        isFileRequest = Boolean(localDictionaryFiles);
                                        return [4 /*yield*/, i18nextRequest({
                                                endpoint: endpoint,
                                                // drop version if file request
                                                version: isFileRequest ? '' : version,
                                                isFileRequest: isFileRequest,
                                            })];
                                    case 2:
                                        _a = _b.sent(), data = _a.data, error = _a.error, errorText = _a.errorText;
                                        if (error) {
                                            throw new Error(errorText);
                                        }
                                        formattedTranslateData = localDictionaryFiles
                                            ? data
                                            : data.translate;
                                        i18next.addResourceBundle(locale, namespace, __assign({}, formattedTranslateData));
                                        return [3 /*break*/, 4];
                                    case 3:
                                        error_1 = _b.sent();
                                        console.error('get error when loading MODULE dict', error_1);
                                        console.error('namespace', namespace);
                                        console.error('locale', locale);
                                        return [3 /*break*/, 4];
                                    case 4: return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    result = _c.sent();
                    return [2 /*return*/, result];
            }
        });
    });
};
